module.exports = __webpack_public_path__ + "static/media/01.d3360d1b.jpg";